import {
  PlayerDetails,
  PlayerDetailsResolver,
} from '@pool-league/frontend-shared-ui-player';
import { Observable, tap } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  PlayerComponentActions,
  playersFeature,
} from '@pool-league/frontend-web-data-players';

@Injectable({
  providedIn: 'root',
})
export class WebPlayerDetailsResolver implements PlayerDetailsResolver {
  readonly #store = inject(Store);

  get(id: string): Observable<PlayerDetails | undefined> {
    return this.#store.select(playersFeature.selectPlayerById(id)).pipe(
      tap((player) => {
        if (!player) {
          this.#store.dispatch(PlayerComponentActions.loadPlayer({ id }));
        }
      }),
    );
  }
}
